import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, normalizeClass as _normalizeClass, vModelText as _vModelText, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "titlebar" }
const _hoisted_2 = { class: "titlebar-content" }
const _hoisted_3 = { class: "titlebar-title --mobile" }
const _hoisted_4 = {
  key: 0,
  class: "titlebar-text"
}
const _hoisted_5 = {
  key: 1,
  style: {"font-size":"16px","margin-left":"10px"},
  class: ""
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("strong", null, "Inspeção ", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("strong", null, "data:", -1)
const _hoisted_8 = { class: "titlebar-actions" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "titlebar-actions-secondary" }, null, -1)
const _hoisted_10 = { class: "titlebar-actions-primary" }
const _hoisted_11 = { class: "ui-button-content" }
const _hoisted_12 = { class: "ui-button-content" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", null, "Valores", -1)
const _hoisted_14 = { class: "ui-button-content" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", null, "Revisão de Inspeção", -1)
const _hoisted_16 = { class: "ui-button-content" }
const _hoisted_17 = { class: "ui-button-content" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", null, "Editar Inspeção", -1)
const _hoisted_19 = ["disabled"]
const _hoisted_20 = { class: "ui-button-content" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("div", null, "Salvar", -1)
const _hoisted_22 = { class: "ui-card" }
const _hoisted_23 = {
  key: 0,
  class: "ui-card-body"
}
const _hoisted_24 = ["disabled"]
const _hoisted_25 = /*#__PURE__*/_createElementVNode("div", { class: "ui-button-content" }, [
  /*#__PURE__*/_createElementVNode("div", null, "Cancelar")
], -1)
const _hoisted_26 = [
  _hoisted_25
]
const _hoisted_27 = /*#__PURE__*/_createElementVNode("div", { class: "ui-button-content" }, [
  /*#__PURE__*/_createElementVNode("div", null, "Confirmar e Enviar")
], -1)
const _hoisted_28 = [
  _hoisted_27
]
const _hoisted_29 = { class: "ant-row" }
const _hoisted_30 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_31 = { class: "ant-row" }
const _hoisted_32 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_icone = _resolveComponent("icone")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_inspecao_dados_principais = _resolveComponent("inspecao-dados-principais")!
  const _component_inspecao_secao1 = _resolveComponent("inspecao-secao1")!
  const _component_inspecao_secao2 = _resolveComponent("inspecao-secao2")!
  const _component_inspecao_secao3 = _resolveComponent("inspecao-secao3")!
  const _component_inspecao_secao4 = _resolveComponent("inspecao-secao4")!
  const _component_inspecao_secao5 = _resolveComponent("inspecao-secao5")!
  const _component_inspecao_secao6 = _resolveComponent("inspecao-secao6")!
  const _component_inspecao_secao7 = _resolveComponent("inspecao-secao7")!
  const _component_inspecao_arquivos = _resolveComponent("inspecao-arquivos")!
  const _component_a_spin = _resolveComponent("a-spin")!
  const _component_a_skeleton = _resolveComponent("a-skeleton")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_campo_email = _resolveComponent("campo-email")!
  const _component_editor_html = _resolveComponent("editor-html")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_modal = _resolveComponent("a-modal")!
  const _component_comunicacao_api = _resolveComponent("comunicacao-api")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(_ctx.storeApp.state.apresentarLogoExterna?'ui-page ui-acesso-externo':'ui-page')
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          (_ctx.state.inspecao.codigo === 0)
            ? (_openBlock(), _createElementBlock("h2", _hoisted_4, _toDisplayString(_ctx.appBase.titulo), 1))
            : (_openBlock(), _createElementBlock("span", _hoisted_5, [
                _hoisted_6,
                _createTextVNode(),
                _hoisted_7,
                _createTextVNode(" " + _toDisplayString(_ctx.UtilitarioData.aplicaFormatoData(_ctx.state.inspecao.dataInspecao)), 1)
              ]))
        ])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _hoisted_9,
        _createElementVNode("div", _hoisted_10, [
          (!_ctx.state.acessoExterno)
            ? (_openBlock(), _createBlock(_component_a_button, {
                key: 0,
                type: "primary",
                class: "ui-button",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.montarEmail()))
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_11, [
                    _createVNode(_component_icone, { nome: "email" }),
                    _createElementVNode("div", null, _toDisplayString(_ctx.state.montandoEmail? 'Aguarde por favor... Estamos preparando o conteúdo do e-mail': 'Enviar E-mail'), 1)
                  ])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (!_ctx.state.acessoExterno && _ctx.state.inspecao.codigo > 0)
            ? (_openBlock(), _createBlock(_component_a_button, {
                key: 1,
                type: "primary",
                class: "ui-button",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.abrirValores()))
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_12, [
                    _createVNode(_component_icone, { nome: "saco-de-dinheiro" }),
                    _hoisted_13
                  ])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (!_ctx.state.acessoExterno && _ctx.state.inspecao.codigo > 0 && _ctx.state.bloquearCampos)
            ? (_openBlock(), _createBlock(_component_a_button, {
                key: 2,
                type: "primary",
                class: "ui-button",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.confirmarRevisaoInspecao()))
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_14, [
                    _createVNode(_component_icone, { nome: "copiar" }),
                    _hoisted_15
                  ])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_ctx.state.gerarPdf)
            ? (_openBlock(), _createBlock(_component_a_button, {
                key: 3,
                type: "primary",
                class: "ui-button",
                loading: _ctx.state.gerandoPdf,
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.gerarPdf()))
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_16, [
                    _createVNode(_component_icone, { nome: "pdf" }),
                    _createTextVNode(),
                    _createElementVNode("div", null, _toDisplayString(_ctx.state.gerandoPdf? 'Aguarde por favor... Estamos gerando o seu PDF': 'Visualizar PDF'), 1)
                  ])
                ]),
                _: 1
              }, 8, ["loading"]))
            : _createCommentVNode("", true),
          (!_ctx.state.gerandoPdf && _ctx.state.bloquearCampos)
            ? (_openBlock(), _createElementBlock("button", {
                key: 4,
                class: "ui-button -second",
                type: "button",
                onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.editarInspecao()))
              }, [
                _createElementVNode("div", _hoisted_17, [
                  _createVNode(_component_icone, { nome: "editar" }),
                  _hoisted_18
                ])
              ]))
            : _createCommentVNode("", true),
          (!_ctx.state.gerandoPdf)
            ? (_openBlock(), _createElementBlock("button", {
                key: 5,
                class: "ui-button -primary",
                type: "button",
                disabled: _ctx.state.bloquearCampos,
                onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.salvar()))
              }, [
                _createElementVNode("div", _hoisted_20, [
                  _createVNode(_component_icone, { nome: "salvar-personalizacoes" }),
                  _hoisted_21
                ])
              ], 8, _hoisted_19))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _createVNode(_component_a_form, { layout: "vertical" }, {
      default: _withCtx(() => [
        _createVNode(_component_a_skeleton, {
          loading: _ctx.appBase.carregando
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_22, [
              (_ctx.state.apresentarCampos)
                ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                    _createVNode(_component_a_spin, {
                      tip: "Aguarde por favor ... Estamos obtendo informações do CNPJ na Receita Federal.",
                      spinning: _ctx.state.consultandoCnpj
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("fieldset", {
                          class: _normalizeClass(["ui-inspecao-edicao", { 'ui-inspecao-bloqueada': _ctx.state.bloquearCampos }]),
                          disabled: _ctx.state.bloquearCampos
                        }, [
                          (_openBlock(), _createBlock(_component_inspecao_dados_principais, {
                            inspecao: _ctx.state.inspecao,
                            "onUpdate:inspecao": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.state.inspecao) = $event)),
                            "bloquear-campos": _ctx.state.bloquearCampos,
                            key: 'DI' + _ctx.state.cnpjHistorico,
                            "acesso-externo": _ctx.state.acessoExterno
                          }, null, 8, ["inspecao", "bloquear-campos", "acesso-externo"])),
                          _createVNode(_component_inspecao_secao1, {
                            secao1: _ctx.state.inspecao.secao1,
                            "onUpdate:secao1": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.state.inspecao.secao1) = $event)),
                            "bloquear-campos": _ctx.state.bloquearCampos
                          }, null, 8, ["secao1", "bloquear-campos"]),
                          _createVNode(_component_inspecao_secao2, {
                            secao2: _ctx.state.inspecao.secao2,
                            "onUpdate:secao2": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.state.inspecao.secao2) = $event)),
                            "bloquear-campos": _ctx.state.bloquearCampos
                          }, null, 8, ["secao2", "bloquear-campos"]),
                          _createVNode(_component_inspecao_secao3, {
                            secao3: _ctx.state.inspecao.secao3,
                            "onUpdate:secao3": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.state.inspecao.secao3) = $event)),
                            "bloquear-campos": _ctx.state.bloquearCampos
                          }, null, 8, ["secao3", "bloquear-campos"]),
                          _createVNode(_component_inspecao_secao4, {
                            secao4: _ctx.state.inspecao.secao4,
                            "onUpdate:secao4": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.state.inspecao.secao4) = $event)),
                            "bloquear-campos": _ctx.state.bloquearCampos
                          }, null, 8, ["secao4", "bloquear-campos"]),
                          _createVNode(_component_inspecao_secao5, {
                            secao5: _ctx.state.inspecao.secao5,
                            "onUpdate:secao5": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.state.inspecao.secao5) = $event)),
                            "bloquear-campos": _ctx.state.bloquearCampos
                          }, null, 8, ["secao5", "bloquear-campos"]),
                          _createVNode(_component_inspecao_secao6, {
                            secao6: _ctx.state.inspecao.secao6,
                            "onUpdate:secao6": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.state.inspecao.secao6) = $event)),
                            "bloquear-campos": _ctx.state.bloquearCampos
                          }, null, 8, ["secao6", "bloquear-campos"]),
                          _createVNode(_component_inspecao_secao7, {
                            secao7: _ctx.state.inspecao.secao7,
                            "onUpdate:secao7": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.state.inspecao.secao7) = $event)),
                            "bloquear-campos": _ctx.state.bloquearCampos
                          }, null, 8, ["secao7", "bloquear-campos"]),
                          _createVNode(_component_inspecao_arquivos, {
                            arquivos: _ctx.state.inspecao.arquivos,
                            "onUpdate:arquivos": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.state.inspecao.arquivos) = $event)),
                            "bloquear-campos": _ctx.state.bloquearCampos,
                            "onUpdate:inspecao": _ctx.marcarAlterado
                          }, null, 8, ["arquivos", "bloquear-campos", "onUpdate:inspecao"])
                        ], 10, _hoisted_24)
                      ]),
                      _: 1
                    }, 8, ["spinning"])
                  ]))
                : _createCommentVNode("", true)
            ])
          ]),
          _: 1
        }, 8, ["loading"]),
        (_ctx.state.apresentarModalEmail)
          ? (_openBlock(), _createBlock(_component_a_modal, {
              key: 0,
              keyboard: false,
              title: "Confirme o conteúdo do e-mail",
              centered: "",
              width: 1200,
              visible: _ctx.state.apresentarModalEmail,
              "onUpdate:visible": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.state.apresentarModalEmail) = $event))
            }, {
              footer: _withCtx(() => [
                _createElementVNode("div", null, [
                  _createElementVNode("button", {
                    class: "ui-button -second",
                    type: "button",
                    onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.state.apresentarModalEmail = false))
                  }, _hoisted_26),
                  _createElementVNode("button", {
                    class: "ui-button -primary",
                    type: "button",
                    onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.confirmarEnvioEmail()))
                  }, _hoisted_28)
                ])
              ]),
              default: _withCtx(() => [
                _createVNode(_component_a_form, { layout: "vertical" }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_29, [
                      _createElementVNode("div", _hoisted_30, [
                        _createVNode(_component_a_form_item, { label: "Assunto" }, {
                          default: _withCtx(() => [
                            _withDirectives(_createElementVNode("input", {
                              type: "text",
                              class: "ant-input",
                              "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.state.enviarEmail.titulo) = $event))
                            }, null, 512), [
                              [_vModelText, _ctx.state.enviarEmail.titulo]
                            ])
                          ]),
                          _: 1
                        })
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_31, [
                      _createElementVNode("div", _hoisted_32, [
                        _createVNode(_component_a_form_item, { label: "Destinatários" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_campo_email, {
                              valor: _ctx.state.enviarEmail.destinatarios,
                              "onUpdate:valor": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.state.enviarEmail.destinatarios) = $event))
                            }, null, 8, ["valor"])
                          ]),
                          _: 1
                        })
                      ])
                    ]),
                    _createVNode(_component_editor_html, {
                      value: _ctx.state.enviarEmail.corpo,
                      "onUpdate:value": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.state.enviarEmail.corpo) = $event)),
                      minHeight: '900'
                    }, null, 8, ["value"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["visible"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_component_comunicacao_api, {
      visivel: _ctx.appBase.exibirComunicaoApi,
      "onUpdate:visivel": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.appBase.exibirComunicaoApi) = $event)),
      apresentarBarraProgresso: _ctx.appBase.apresentarBarraProgresso,
      fraseBarraProgresso: _ctx.appBase.fraseBarraProgresso,
      resposta: _ctx.appBase.resposta
    }, null, 8, ["visivel", "apresentarBarraProgresso", "fraseBarraProgresso", "resposta"])
  ], 2))
}